import { select } from "redux-saga/effects"
import { selectLoggedInArtistID } from "../../auth/authSelector"
import { selectArtistMap } from "../../common/commonSelector"

export function* getLoggedInArtistLocale() {
    const loggedInArtistId = yield select(state => selectLoggedInArtistID(state))
    const artistMap = yield select(state => selectArtistMap(state))
    const locale = artistMap && loggedInArtistId && artistMap[loggedInArtistId]?.locale
    return locale
}


